module.exports = __webpack_public_path__ + "img/n_cj_zz.6bc33cf4.png";